import React, { useEffect, useRef } from 'react';
import { useContext } from 'react';
import { Box, Button } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { AppContext } from '/@/app/AppContext';


//
// Useful for Rutube / VK / YouTube / Vimeo / etc. videos
//
// Specify aspectRatio received from the video source.
//
// Requirements:
// 1. Opens on click.
// 1.1. For desktops, no fullscreen.
// 1.2. For mobiles, fullscreen.  (not always work)
// 2. Shows a placeholder image at once.
// 3. We want to play it with sound.
// 3.1. On Chrome, it works with autoplay.
// 3.2. On Safari, we don't start autoplay, because it will be muted.
//

export const IFrameVideo = ({ src, placeholderContentId, aspectRatio = 720 / 405, sx }) => {
    const { content } = useContext(AppContext).bootstrapData.help;
    const iframeRef = useRef(null);
    const [opened, setOpened] = React.useState(false);

    // FIXME move it to utils
    const isMobileDevice = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileUserAgent = /android|iPad|iPhone|iPod/i.test(userAgent);
        const isSmallScreen = window.innerWidth <= 768;
        return isMobileUserAgent || isSmallScreen;
    };
    const isSafari = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('safari') && !userAgent.includes('chrome');
    };


    const handlePlay = () => {
        setOpened(true);
        if (!isMobileDevice()) {
            return; // Do not enable fullscreen on desktop/laptop
        }
        const iframe = iframeRef.current;
        if (iframe.requestFullscreen) {
            iframe.requestFullscreen();
        } else if (iframe.mozRequestFullScreen) { /* Firefox */
            iframe.mozRequestFullScreen();
        } else if (iframe.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            iframe.webkitRequestFullscreen();
        } else if (iframe.msRequestFullscreen) { /* IE/Edge */
            iframe.msRequestFullscreen();
        }
    };

    let allow = "encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
    if (!isSafari()) {
        src = src + "&autoplay=1";
        allow = "autoplay; " + allow;
    }

    return (
        <Box sx={{
            position: 'relative',
            width: '100%',
            paddingTop: `${(1 / aspectRatio) * 100}%`,
            ...sx
        }}>
            <Box component="iframe"
                 ref={iframeRef}
                 src={src}
                 frameBorder="0"
                 allow={allow}
                // a tricky notation here. Just followed React's warnings:
                 webkitallowfullscreen="true"
                 mozallowfullscreen="true"
                 allowFullScreen={true}
                //
                 sx={{
                     display: opened ? 'block' : 'none',
                     zIndex: "100", position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            ></Box>

            {/* Content shown when the video is loading */}
            <Box
                sx={{
                    zIndex: "99",
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexFlow: 'column wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundImage: `url(${content[placeholderContentId]})`,
                    backgroundSize: 'cover',
                    gap: 3,
            }}
            >
                <Button onClick={handlePlay} sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    borderRadius: '50%',
                }}>
                    <PlayArrowIcon sx={{ fontSize: 150 }} />
                </Button>
            </Box>
        </Box>
    );
};
